import { isNullOrUndefined } from '../general-helpers';

export const ensureAbsoluteUri = (uriString) => {
    const isAbsolute = /:\/\//.test(uriString);

    if (!isAbsolute) {
        uriString = 'https://' + uriString;
    }

    return uriString;
};

export const ensureValidUri = (uriString) => {
    const isAbsolute = /:\/\//.test(uriString);

    if (isNullOrUndefined(uriString)) {
        return uriString;
    }

    if (!isAbsolute) {
        if (!uriString.startsWith('/')) {
            return `${window.location.origin}/${uriString}`;
        }

        return `${window.location.origin}${uriString}`;
    }

    return uriString;
};
